export const generateFileUrl = (base64String: string, mimeType: string) => {
  const byteString = atob(base64String);
  const buffer = new ArrayBuffer(byteString.length);
  const bites = new Uint8Array(buffer);
  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < byteString.length; i++) {
    bites[i] = byteString.charCodeAt(i);
  }

  return window.URL.createObjectURL(new Blob([buffer], { type: mimeType }));
};
